const API_BASE = import.meta.env.VITE_API_URL ?? '';

export function assetUrl(path) {
  if (!path || /^https?:\/\//i.test(path)) return path;
  return `${API_BASE}${path}`;
}

function getToken() {
  return localStorage.getItem('mg_token');
}

function buildAuthHeader() {
  const t = getToken();
  if (!t) return {};
  const prefix = 'Bearer ';
  return { Authorization: prefix + t };
}

async function req(method, path, body, isFormData = false) {
  const headers = { ...buildAuthHeader() };
  if (!isFormData && body) headers['Content-Type'] = 'application/json';

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: isFormData ? body : body != null ? JSON.stringify(body) : undefined,
  });

  let data;
  const ct = res.headers.get('Content-Type') ?? '';
  if (ct.includes('application/json')) {
    data = await res.json();
  } else {
    data = {};
  }

  if (!res.ok) {
    const msg = data?.error ?? data?.message ?? `HTTP ${res.status}`;
    throw Object.assign(new Error(msg), { status: res.status });
  }
  return data;
}

export const api = {
  auth: {
    signup: (d) => req('POST', '/api/auth/signup', d),
    signin: (d) => req('POST', '/api/auth/signin', d),
  },
  users: {
    me: () => req('GET', '/api/users/me'),
    getById: (id) => req('GET', `/api/users/${id}`),
    updateMe: (d) => req('PUT', '/api/users/me', d),
    uploadAvatar: (fd) => req('POST', '/api/users/me/avatar', fd, true),
  },
  caddies: {
    list: (params = {}) => req('GET', `/api/caddies?${new URLSearchParams(params)}`),
    courses: () => req('GET', '/api/caddies/courses'),
    toggleFollow: (id) => req('POST', `/api/caddies/${id}/follow`),
    updateProfile: (d) => req('PUT', '/api/caddies/me/profile', d),
    getAvailability: (id, month) =>
      req('GET', `/api/caddies/${id}/availability${month ? `?month=${month}` : ''}`),
    setAvailability: (d) => req('PUT', '/api/caddies/me/availability', d),
  },
  golfers: {
    updateProfile: (d) => req('PUT', '/api/golfers/me/profile', d),
  },
  posts: {
    feed: (page = 1, params = {}) => req('GET', `/api/posts?${new URLSearchParams({ page, ...params })}`),
    get: (id) => req('GET', `/api/posts/${id}`),
    create: (fd) => req('POST', '/api/posts', fd, true),
    delete: (id) => req('DELETE', `/api/posts/${id}`),
    like: (id) => req('POST', `/api/posts/${id}/like`),
    getLikes: (id) => req('GET', `/api/posts/${id}/likes`),
  },
  messages: {
    send: (d) => req('POST', '/api/messages', d),
    conversations: () => req('GET', '/api/messages/conversations'),
    unreadCount: () => req('GET', '/api/messages/unread-count'),
    history: (userId) => req('GET', `/api/messages/${userId}`),
  },
};
